import {
  BaseRecord,
  HttpError,
  IResourceComponentsProps,
} from "@refinedev/core";
import { Create, useForm } from "@refinedev/mantine";
import {
  TextInput,
  Select,
  Textarea,
  Box,
  Divider,
  Text,
  Flex,
  Badge,
} from "@mantine/core";
import { isNotEmpty } from "@mantine/form";
import {
  CreateReviewRequestBlacklist,
  REASON_OPTIONS,
  REASON_COLORS,
  REASON_DESCRIPTIONS,
} from "entities/review_request_blacklist";

export const ReviewRequestBlacklistCreate: React.FC<
  IResourceComponentsProps
> = () => {
  const { getInputProps, saveButtonProps, values } = useForm<
    BaseRecord,
    HttpError,
    CreateReviewRequestBlacklist
  >({
    initialValues: {
      email: "",
      reason: "no_consent",
      source_detail: "",
    },
    validateInputOnBlur: true,
    validate: {
      email: (value) => {
        if (!value) return "Email is required";
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
          return "Please enter a valid email address";
        return null;
      },
      reason: isNotEmpty("Reason is required"),
    },
  });

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Box>
        <Text size="lg" mb="xs" color="cyan">
          Blacklist Entry
        </Text>
        <Text size="sm" color="dimmed" mb="md">
          Add an email address to prevent review requests from being sent to
          this recipient.
        </Text>
        <Divider mb="lg" />
      </Box>

      <Flex direction="column" gap="md">
        <TextInput
          label="Email"
          placeholder="user@example.com"
          description="The email address to blacklist from review requests"
          withAsterisk
          {...getInputProps("email")}
        />

        <Select
          label="Reason"
          placeholder="Select reason"
          description={
            values.reason ? REASON_DESCRIPTIONS[values.reason] : undefined
          }
          data={REASON_OPTIONS}
          withAsterisk
          {...getInputProps("reason")}
        />

        {values.reason && (
          <Badge
            variant="filled"
            color={REASON_COLORS[values.reason] || "gray"}
            size="sm"
            radius="sm"
            sx={{ alignSelf: "flex-start" }}
          >
            {REASON_OPTIONS.find((o) => o.value === values.reason)?.label ||
              values.reason}
          </Badge>
        )}

        <Textarea
          label="Source Detail"
          placeholder="e.g., Customer support ticket #1234, User request via email"
          description="Optional context about why this email was blacklisted"
          minRows={3}
          {...getInputProps("source_detail")}
        />
      </Flex>
    </Create>
  );
};
